import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import MoinstroisSearch from "./MoinstroisSearch";
import GnssWaveEffect from "./GnssWaveEffect";
import "./AuroraTheme.css";

function HomePage() {
  return (
    <main className="aurora-app">
      <GnssWaveEffect />
      <div className="aurora-content">
        <MoinstroisSearch />
      </div>
    </main>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/sweden" element={<Navigate to="/" replace />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
